import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import GenericModals from '@/components/GenericModals/GenericModals';
import Page from '@/components/Page/Page';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import spliceHeaderFromContentItems from '@/helpers/spliceHeaderFromContentItems';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import type { PageModel } from '@/models/page';
import EnercityFooter from '@uikit/components/EnercityFooter/EnercityFooter';
import PressPageTitle from '@uikit/components/Press/PressPageTitle/PressPageTitle';
import PressFilter from '@uikit/components/PressFilter/PressFilter';
import PressLayout from '@uikit/components/PressLayout/PressLayout';
import Section from '@uikit/components/Section/Section';
import { SectionVariant } from '@uikit/components/Section/consts';
import React from 'react';
import { CmsComponentsContext } from '../CmsComponentsContext';
import cmsComponents from './PressOverviewPage.cmsComponents';
import type { PressOverviewPageProps } from './interface';

const PressOverviewPage = (
  routeData: PageModel<PressOverviewPageProps>,
  { children }: { children: React.ReactNode }
): JSX.Element => {
  const meta = extractPageMetaFromRouteData(routeData);

  const {
    contents,
    modals,
    props: {
      initialPressArticles = [],
      mediaTypes = [],
      title,
      subTitle,
      pressType,
      tags,
    },
  } = routeData;

  const { header } = spliceHeaderFromContentItems(contents);
  const {
    extractedContents: [additionalContents],
  } = extractContents(['additional-contents'], contents);

  useInitialPageDataLayer();

  return (
    <CmsComponentsContext.Provider value={cmsComponents}>
      <PressLayout>
        <Page meta={meta}>
          {header && <ContentsToReact contents={[header]} />}

          <PressPageTitle title={title} subText={subTitle} />
          <Section variant={SectionVariant.Default}>
            <PressFilter
              initialPressArticles={initialPressArticles}
              pressType={pressType}
              tags={tags}
              mediaTypes={mediaTypes}
            >
              {children}
            </PressFilter>
          </Section>

          {additionalContents && (
            <ContentsToReact contents={additionalContents} />
          )}
        </Page>
        <EnercityFooter />
      </PressLayout>
      <GenericModals modals={modals} />
    </CmsComponentsContext.Provider>
  );
};

export default PressOverviewPage;
